import { GeoCoordinates } from '@aloft/toolkit-shared';

import { useEffect } from 'react';

import MapBox from '../../../../components/map/MapBox.js';

type Props = {
  mapRef: React.RefObject<MapBox>;
  coordinates: GeoCoordinates;
};

export function useRedrawPolygon({ mapRef, coordinates }: Props) {
  useEffect(() => {
    if (!mapRef.current) return;

    const { getGeoCoords, getDraw, disablePolygonDrawButton, enableTrashButton } = mapRef.current;

    const currentPolygons = getGeoCoords();
    if (currentPolygons.length > 1) {
      throw new Error('Multiple polygons not supported');
    }

    const currentPolygon = currentPolygons[0];
    const shouldRedrawPolygon = !currentPolygon?.length && !!coordinates.length;

    if (shouldRedrawPolygon) {
      disablePolygonDrawButton();
      enableTrashButton();

      const draw = getDraw();
      draw.add({
        type: 'Feature',
        geometry: {
          type: 'Polygon',
          coordinates: [coordinates],
        },
        properties: {},
      });
    } else if (!coordinates.length) {
      getDraw().changeMode('draw_polygon');
    }
  }, [coordinates, mapRef]);
}
